import { ConfigProvider } from 'tea-component';
import React from 'react';
import { FormatOptionsParamsType } from '../../components/NewFilter/_type';
import { LANGUAGE_CN } from '@/pages/dashboard/_config/constant';
import SelectFilter from './components/selectFilter';

import en_US from "tea-component/es/i18n/locale/en_US";
import zh_CN from "tea-component/es/i18n/locale/zh_CN";
import './filterList.scss';

const formatOptions: (option: FormatOptionsParamsType) => Array<any> = ({ options, valueKey, locale, cnKey = '', enKey = '' }) => (options || [])?.map((item: any) => {
  const text = (locale === LANGUAGE_CN ? item?.[cnKey] : item?.[enKey]) || item?.[enKey] || item?.[cnKey];
  return {
    ...item,
    value: item?.[valueKey],
    text
  };
});

export const renderMetric = (props: any): React.ReactElement => {
  const { key, value, options, defaultValue, onChange, locale, getLocalText, name, ...restProps } = props || {};

  return <ConfigProvider locale={locale === 'en-US' ? en_US : zh_CN}>
    <SelectFilter
      label={name || getLocalText('selector_multiple_component_metrics_label', {}, false)}
      // allDescribe={getLocalText('selector_multiple_component_competitor_all_describe', {}, false)}
      // 此处使用解构赋值的方式解决初次渲染结果没有全选的问题
      className='search-item dbd-meitric-search-item'
      value={value}
      defaultValue={defaultValue}
      lastOneMessage={''}
      onChange={(value) => {
        onChange(key, value);
      }}
      disabledConfig={
        {
          lmitLength: 6,
          disableToolTips: getLocalText('selector_limit_msg', {}, false)
        }
      }
      options={formatOptions({
        options,
        locale,
        valueKey: 'metric',
        cnKey: 'metric_name_ch',
        enKey: 'metric_name_en',
      })}
      {...restProps}
    />
  </ConfigProvider>;
};